/**
 * Green banner shown when a family voice note is playing.
 */

import { FC } from "react";
import "./voice-note-indicator.scss";

interface VoiceNoteIndicatorProps {
  isPlaying: boolean;
  sender: string;
}

const VoiceNoteIndicator: FC<VoiceNoteIndicatorProps> = ({
  isPlaying,
  sender,
}) => {
  if (!isPlaying) return null;

  return (
    <div className="voice-note-indicator">
      <span className="voice-note-indicator__icon">&#9835;</span>
      <span>
        Голосовое сообщение{sender ? ` от ${sender}` : ""}
      </span>
    </div>
  );
};

export default VoiceNoteIndicator;
